import Header from '../../components/pageHeader'
import config from './config'
import axios from 'axios'
import baseconfig from '../../../../variables/config'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { fetchClasses } from '../../../../modules/classes'
import { sendRequest } from '../../../../modules/admin'
import S3 from 'react-aws-s3'
import Dropzone from 'react-dropzone'

const Banner = () => {
  const [tab, setTab] = useState(0)
  const [tabs, setTabs] = useState([])
  const [showItems, setShowItems] = useState([])
  const [toggle, setToggle] = useState('')
  const [image, setImage] = useState('')
  const [content, setContent] = useState('')
  const [editSwitch, setEditSwitch] = useState(-1)

  useEffect(() => {
    sendRequest(fetchClasses)
    fetchAdditionsList()
    var cb = i => setTab(i)
    setTabs([{ name: '', cb: () => cb(0) }])
  }, [])

  const imageConfig = {
    bucketName: 'wackykingdom',
    dirName: 'media' /* optional */,
    region: 'eu-west-2',
    accessKeyId: process.env.REACT_APP_S3Key,
    secretAccessKey: process.env.REACT_APP_S3SecretAccessKey,
    s3Url: 'https://wackykingdom.s3.eu-west-2.amazonaws.com' /* optional */
  }

  const uploadImage = file => {
    const ReactS3Client = new S3(imageConfig)
    /*  Notice that if you don't provide a dirName, the file will be automatically uploaded to the root of your bucket */

    /* This is optional */
    const newFileName =
      'banner-' + JSON.stringify(Date.now()) + '-' + file[0].name

    ReactS3Client.uploadFile(file[0], newFileName)
      .then(data => {
        const classes = [...showItems]
        classes[editSwitch].image = data.location
        setImage(data.location)
        setShowItems(classes)
      })
      .catch(err => console.error(err))
  }

  const itemStructure = {
    pageName: 'Name',
    header: '',
    subheader: '',
    buttonColour: 'green',
    image: 'Upload Image',
    slideNumber: 0,
    hasButton: false,
    buttonLink: 'string',
    buttonText: 'string'
  }

  const fetchAdditionsList = async () => {
    let token = JSON.parse(window.localStorage.getItem('userData')).token
    const extraItems = (await axios.get(
      baseconfig.serverURL + '/Banners' + '?access_token=' + token
    )).data

    setShowItems(extraItems)
  }

  const addItem = () => {
    var newItems = [...showItems]
    newItems.push(itemStructure)
    setShowItems(newItems)
  }

  const updateItem = async i => {
    if (!showItems[i].id) {
      let token = JSON.parse(window.localStorage.getItem('userData')).token
      let response = {}
      try {
        response = await axios.post(
          baseconfig.serverURL + '/Banners',
          showItems[i]
        )
        // console.log(response, 'response')
        setEditSwitch(-1)
        fetchAdditionsList()
      } catch (err) {
        if (response.data.status === 'success') {
          console.log('response ok')
        } else {
          throw new Error('Please fill all fields')
        }
      }
    } else {
      let token = JSON.parse(window.localStorage.getItem('userData')).token
      let response = {}
      try {
        response = await axios.patch(
          baseconfig.serverURL +
            '/Banners/' +
            showItems[i].id +
            '?access_token=' +
            token,
          showItems[i]
        )
        console.log(response, 'response')
        setEditSwitch(-1)
        fetchAdditionsList()
      } catch (err) {
        if (response.data.status === 'success') {
          console.log('response ok')
        } else {
          throw new Error('Please fill all fields')
        }
      }
    }
  }

  const deleteItem = async i => {
    if (window.confirm('Are you sure you want to delete?')) {
      let token = JSON.parse(window.localStorage.getItem('userData')).token
      let response = []
      try {
        response = await axios.delete(
          baseconfig.serverURL +
            '/Banners/' +
            showItems[i].id +
            '?access_token=' +
            token
        )
        console.log(response, 'response')
        setEditSwitch(-1)
        fetchAdditionsList()
      } catch (err) {
        if (response.data.status === 'success') {
          console.log('response ok')
        } else {
          throw new Error(response.data.error)
        }
      }
    } else {
      console.log('cancel ok')
    }
  }

  const handleContent = event => {
    const target = event.target
    const value = target.type === 'checkbox' ? target.checked : target.value
    setContent(value)
  }

  const handleChange = (event, index) => {
    const target = event.target
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name

    var newData = { ...showItems[editSwitch] }
    var newItems = [...showItems]

    newData[name] = value
    newItems[editSwitch][name] = value
    setShowItems(newItems)
  }

  const addContent = (option, i) => {
    var newItems = [...showItems]
    newItems[i][option].push(content)
    setShowItems(newItems)
    setToggle('')
    setContent('')
  }

  var itemsList = showItems.map((item, index) => (
    <div className="orderContent" key={index}>
      {editSwitch === index ? (
        <li>
          <span>
            <label>Page Name:</label>
            <input
              value={item.pageName}
              name="pageName"
              className="column"
              placeholder="name"
              onChange={handleChange}
            />
          </span>
          <br />
          <span>
            <label>Header:</label>
            <input
              value={item.header}
              name="header"
              className="column"
              placeholder=""
              onChange={handleChange}
            />
            <label>Sub Header:</label>
            <p></p>
            <input
              value={item.subheader}
              name="subheader"
              className="column"
              placeholder=""
              onChange={handleChange}
            />
          </span>
          <br />
          <span>
            <label>Button Colour:</label>
            <input
              value={item.buttonColour}
              name="buttonColour"
              className="column"
              placeholder=""
              onChange={handleChange}
            />
          </span>
          <br />
          <span>
            <label>Image:</label>
            <input
              value={item.image}
              name="image"
              className="column"
              placeholder=""
              onChange={handleChange}
            />
          </span>
          <Dropzone onDrop={acceptedFiles => uploadImage(acceptedFiles)}>
            {({ getRootProps, getInputProps }) => (
              <section>
                <div {...getRootProps()}>
                  <input {...getInputProps()} />
                  <button>Upload Image</button>
                </div>
              </section>
            )}
          </Dropzone>
          <br />
          <label>Has Button:</label>
          <label className="switch">
            <input
              type="checkbox"
              name="hasButton"
              checked={item.hasButton}
              onChange={handleChange}
            />
            <span className="slider round"></span>
          </label>
          <br />
          <span>
            <label>Button Text:</label>
            <input
              value={item.buttonText}
              name="buttonText"
              className="column"
              placeholder=""
              onChange={handleChange}
            />
          </span>
          <br />
          <span>
            <label>Button Link:</label>
            <input
              value={item.buttonLink}
              name="buttonLink"
              className="column"
              placeholder=""
              onChange={handleChange}
            />
          </span>
          <br />
          <span>
            <label>Slider Number:</label>
            <input
              value={item.slideNumber}
              name="slideNumber"
              className="column"
              placeholder=""
              type="number"
              onChange={handleChange}
            />
          </span>
          <br />
          <label>Hide:</label>
          <label className="switch">
            <input
              type="checkbox"
              name="isHidden"
              checked={item.isHidden}
              onChange={handleChange}
            />
            <span className="slider round"></span>
          </label>
          <br />

          <div className="orderOperation">
            <button onClick={() => setEditSwitch(-1)}>{'Cancel'}</button>
            <button onClick={() => updateItem(index)}>{'Save'}</button>
          </div>
        </li>
      ) : (
        <li>
          <h3>{item.header} </h3>
          <div className="list">
            Image:{' '}
            <img
              src={item.image}
              width="auto"
              height="80"
              style={{ display: 'inline' }}></img>
          </div>
          <br />
          <label>Sub Header:</label>
          <p>{item.subheader}</p>
          <label>Page Name:</label>
          <p>{item.pageName}</p>
          {item.hasButton && (
            <a href={item.buttonLink} style={{ color: `${item.buttonColour}` }}>
              {item.buttonText}
            </a>
          )}
        </li>
      )}
      <div className="orderOperation">
        <button onClick={() => deleteItem(index)}>{'Delete'}</button>

        {editSwitch === index ? (
          <button onClick={() => updateItem(index)}>{'Save'}</button>
        ) : (
          <button onClick={() => setEditSwitch(index)}>{'Edit'}</button>
        )}
      </div>
    </div>
  ))

  return (
    <div className="ordersContainer">
      <Header
        title={config.mainTitle}
        tip={config.subHeading}
        icon={config.titleIcon}
        tabs={tabs}
        selected={tab}
      />
      <div className="orderList">{itemsList}</div>
      <button onClick={() => addItem()}>{'Add New Item'}</button>
    </div>
  )
}

const mapStateToProps = ({ classes }) => ({
  classes: classes
})

const mapDispatchToProps = dispatch =>
  bindActionCreators({ sendRequest }, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Banner)
